module.exports = __webpack_public_path__ + "img/react.fad225a9.png";